export const labels = {
  headerBtnBack: 'กลับสู่หน้าหลัก',
  formBtnAddMore: 'เพิ่มส่วนผสมอื่นๆ "คลิก"',
  formBtnCalculateCost: 'คำนวณต้นทุน',
  formHeaderAmountPerPackage: 'ปริมาณต่อบรรจุภัณฑ์ (เช่น ถุงละ 1000 กรัม)',
  formHeaderAmountPerRecipe: 'ปริมาณที่ใช้ในสูตร',
  formHeaderCostBaht: 'ต้นทุนต่อวัตถุดิบ (บาท)',
  formHeaderCostPerPackage:
    'ราคาต่อบรรจุภัณฑ์ (เช่น ถุง 1000 กรัม ราคา xx บาท)',
  formHeaderIngredient: 'ส่วนผสม',
  formHeaderTitleDefault: 'คำนวณต้นทุนง่ายๆ By Kingbakery',
  formHeaderUnit: 'หน่วย',
  recipeSelectDefaultOption: 'เลือกเมนู...',
  recipeSelectHeader: 'เมนูยอดฮิต',
  resultCostSummary: 'สรุปราคาต้นทุน',
  resultBaht: 'บาท',
};

export const labelsEN = {
  headerBtnBack: 'Back to Home',
  formBtnAddMore: 'Add More Ingredients',
  formBtnCalculateCost: 'Calculate Cost',
  formHeaderAmountPerPackage: 'Amount per Package',
  formHeaderAmountPerRecipe: 'Amount per Recipe',
  formHeaderCostBaht: 'Cost (Baht)',
  formHeaderCostPerPackage: 'Cost per Package',
  formHeaderIngredient: 'Ingredient',
  formHeaderTitleDefault: 'Menu',
  formHeaderUnit: 'Unit',
  recipeSelectDefaultOption: 'Select one',
  recipeSelectHeader: 'Recipes',
  resultCostSummary: 'Cost Summary:',
  resultBaht: 'Baht',
};
